import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  AccionesRol,
  ICodigosDispositivo,
  IFilter,
  IPopulate,
  IQueryParam,
  TipoDispositivo,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { CodigosDispositivosService } from '../../../../auxiliares/servicios/http/codigos-dispositivos.service';
import { DetallesCodigosDispositivosComponent } from '../detalles-codigos-dispositivos/detalles-codigos-dispositivos.component';
import { ClonadorComponent } from '../../clonador/clonador.component';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../auxiliares/html-seguro.util';
import { estadoHtml } from '../../../../auxiliares/tabla/celdas';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-codigos-dispositivos',
  templateUrl: './listado-codigos-dispositivos.component.html',
  styleUrl: './listado-codigos-dispositivos.component.scss',
})
export class ListadoCodigosDispositivoComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(CodigosDispositivosService);
  private formularios = inject(FormularioDialogService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);

  public tipo?: TipoDispositivo;
  //// Tabla nueva
  public name = 'ListadoCodigosDispositivoComponent';
  public codigosDispositivos?: ICodigosDispositivo[];
  public totalCount = 0;
  public columnas?: IColumnas<ICodigosDispositivo>[];
  //Subs
  public codigosDispositivos$?: Subscription;
  //

  //Permisos
  private puedeCrear: AccionesRol;
  private puedeEditar: AccionesRol;
  private puedeEliminar: AccionesRol;

  public botonCrear: ICrearBoton;
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];

  //Query
  public filter: IFilter<ICodigosDispositivo> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'codigos.categoriaEvento',
      select: 'nombre atender',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };
  // Listars
  public async listar(): Promise<void> {
    const filter: IFilter<ICodigosDispositivo> = this.query.filter
      ? JSON.parse(this.query.filter)
      : {};
    filter.tipo = this.tipo;
    this.query.filter = JSON.stringify(filter);

    //
    this.codigosDispositivos$?.unsubscribe();
    this.codigosDispositivos$ = this.lista2
      .codigoDispositivos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.codigosDispositivos = data.datos;
      });
  }

  // Acciones
  public crearCodigos() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(codigosAlarma: ICodigosDispositivo) {
    this.navigator.navigate(['editar', codigosAlarma._id], {
      relativeTo: this.route,
    });
  }

  public async codigos(codigosAlarma: ICodigosDispositivo) {
    this.formularios.abrir(DetallesCodigosDispositivosComponent, {
      tamano: 'mediano',
      data: codigosAlarma,
      cerrarAfuera: true,
    });
  }

  public async clonar(codigosAlarma: ICodigosDispositivo) {
    this.formularios.abrir(ClonadorComponent, {
      tamano: 'chico',
      data: {
        idEntidad: codigosAlarma._id,
        entidad: 'codigoDispositivo',
        nombre: codigosAlarma.nombre,
      },
    });
  }

  public async eliminar(codigosalarma: ICodigosDispositivo) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar los códigos de ${codigosalarma.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(codigosalarma._id!);
      this.helper.notifSuccess('Códigos eliminados');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<ICodigosDispositivo>[] = [
      // Nombre
      {
        header: {
          label: 'Nombre',
          sortable: true,
          sort: 'nombre',
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col"><span class="tabla-principal">${escaparHtml(dato.nombre)}</span>`;
            if (dato.global) {
              html += `<span>${estadoHtml({ texto: 'Global', tono: 'info', icono: 'public' })}</span>`;
            }
            return html + '</div>';
          },
        },
      },
      // Códigos

      {
        header: {
          label: 'Códigos',
        },
        row: {
          parse: (dato) => {
            return (
              (dato.codigos?.length || 0) + (dato.codigosEntrada?.length || 0)
            );
          },
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    // Acciones

    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(this.puedeEditar) ||
              (dato.global && !this.helper.esNivel0()),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.codigos(dato),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'content_copy',
            tooltip: 'Clonar códigos',
            click: (dato) => this.clonar(dato),
            disabled: () => !this.helper.tienePermiso(this.puedeEditar), //Debería existir un permiso de clonar??? ⚠️⚠️⚠️
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(this.puedeEliminar) ||
              (dato.global && !this.helper.esNivel0()),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }

    this.route.params.subscribe(async (params) => {
      this.tipo = params['tipo'] as TipoDispositivo;

      switch (this.tipo) {
        case 'Tracker':
          this.puedeCrear = 'Configuraciones - Crear codigos trackers';
          this.puedeEditar = 'Configuraciones - Editar codigos trackers';
          this.puedeEliminar = 'Configuraciones - Eliminar codigos trackers';
          break;
        case 'Dashcam':
          this.puedeCrear = 'Configuraciones - Crear codigos dashcams';
          this.puedeEditar = 'Configuraciones - Editar codigos dashcams';
          this.puedeEliminar = 'Configuraciones - Eliminar codigos dashcams';
          break;
        case 'Alarma':
          this.puedeCrear = 'Configuraciones - Crear codigos alarmas';
          this.puedeEditar = 'Configuraciones - Editar codigos alarmas';
          this.puedeEliminar = 'Configuraciones - Eliminar codigos alarmas';
          break;
        case 'Comunicador':
          this.puedeCrear = 'Configuraciones - Crear codigos comunicadores';
          this.puedeEditar = 'Configuraciones - Editar codigos comunicadores';
          this.puedeEliminar =
            'Configuraciones - Eliminar codigos comunicadores';
          break;
        case 'DispositivoLorawan':
          this.puedeCrear =
            'Configuraciones - Crear codigos dispositivos lorawan';
          this.puedeEditar =
            'Configuraciones - Editar codigos dispositivos lorawan';
          this.puedeEliminar =
            'Configuraciones - Eliminar codigos dispositivos lorawan';
          break;
        case 'BotonBLE':
          this.puedeCrear = 'Configuraciones - Crear codigos botones BLE';
          this.puedeEditar = 'Configuraciones - Editar codigos botones BLE';
          this.puedeEliminar = 'Configuraciones - Eliminar codigos botones BLE';
          break;
        case 'Sirena':
          this.puedeCrear = 'Configuraciones - Crear codigos sirenas';
          this.puedeEditar = 'Configuraciones - Editar codigos sirenas';
          this.puedeEliminar = 'Configuraciones - Eliminar codigos sirenas';
          break;
      }

      this.botonCrear = {
        mostrar: this.helper.tienePermiso(this.puedeCrear),
        tooltip: 'Crear códigos',
        color: 'primary',
        tipo: 'material',
        icon: 'add',
        accion: () => this.crearCodigos(),
      };
      await Promise.all([this.listar()]);
    });
    this.setColumnas();
  }

  async ngOnDestroy() {
    this.codigosDispositivos$?.unsubscribe();
  }
}
